<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('training.title') +' ' + $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xl="12" lg="12" sm="12">
                           <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Year" vid="year">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="year "
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_student_management.year')}}
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        v-model="search.year"
                                                        id="year"
                                                        :options="yearList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Organization Name" vid="organization_id">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="organization_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('globalTrans.organization')}}
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="search.org_id"
                                                    id="organization_id"
                                                    :options="orgList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :disabled="$store.state.Auth.authUser.role_id === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="institute_type_id">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="institute_type "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('ds_config.institute_type')}}
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="search.office_type_id"
                                                    id="institute_type_id"
                                                    :options="officeTypeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                           <ValidationProvider name="Institute Name" vid="institute_name">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="institute_name "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('ds_institute_management.institute_name')}}
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="search.office_id"
                                                    id="institute_name"
                                                    :options="officeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="6" lg="6">
                                          <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            :label="$t('ds_config.trainee_type')"
                                            label-for="trainee_type"
                                          >
                                            <b-form-select
                                              plain
                                              id="trainee_type"
                                              v-model="search.trainee_type"
                                              :options="traineeTypeList"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                            </b-form-select>
                                          </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </ValidationObserver>
            </b-col>
        </b-row>
        <b-row>
          <b-col class="text-left" xs="12" sm="12" md="8" lg="12" xl="12">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('training.titles')  + ' ' +  $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              {{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                      <template v-slot:cell(date_to)="data">
                          {{ data.item.date_to | dateFormat }}
                      </template>
                      <template v-slot:cell(date_from)="data">
                          {{ data.item.date_from | dateFormat }}
                      </template>
                   <template v-slot:cell(action)="data">
                     <div style="width: 150px">
                         <b-button v-b-modal.modal-2 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Details" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>
                         <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button>
                     </div>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :item="item" :id="editItemId" :key="editItemId"/>
    </b-modal>
    <b-modal id="modal-2" size="md" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :item="item" :id="viewitemId" :key="viewitemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Form from './Form'
import Details from './Details'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { ParentTrainingList } from '../../api/routes'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form,
    Details,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      search: {
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        year: 0,
        trainee_type: 0
      },
      editItemId: 0,
      viewitemId: 0,
      rows: [],
      officeTypeList: [],
      officeList: [],
        item: []
    }
  },
  computed: {
    traineeTypeList: function () {
      return this.$store.state.DisabilitySchoolService.commonObj.traineeTypeList.map(el => {
        return Object.assign({}, el, { text: this.$i18n.locale === 'bn' ? el.text_bn : el.text_en })
      })
    },
    formTitle () {
       return (this.editItemId === 0) ? this.$t('training.title') + ' ' + this.$t('globalTrans.entry') : this.$t('training.title') + ' ' + this.$t('globalTrans.modify')
    },
    ViewTitle () {
        return this.$t('training.titles') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('ds_config.organization'), class: 'text-left' },
          { label: this.$t('ds_institute_management.institute_type'), class: 'text-left' },
          { label: this.$t('ds_institute_management.institute_name'), class: 'text-left' },
          { label: this.$t('ds_config.trainee_type'), class: 'text-left' },
          { label: this.$t('training.training_title'), class: 'text-left' },
          { label: this.$t('training.from'), class: 'text-left' },
          { label: this.$t('training.to'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'organization_name_bn' },
          { key: 'institute_type_name_bn' },
          { key: 'institute_name_bn' },
          { key: 'trainee_type_bn' },
          { key: 'training.training_name_bn' },
          { key: 'date_from' },
          { key: 'date_to' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'organization_name' },
          { key: 'institute_type_name' },
          { key: 'institute_name' },
          { key: 'trainee_type_en' },
            { key: 'training.training_name' },
            { key: 'date_from' },
            { key: 'date_to' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
      yearList: function () {
          return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
              if (this.$i18n.locale === 'bn') {
                  return { value: item, text: this.$n(item, { useGrouping: false }) }
              } else {
                  return item
              }
          })
      },
    ...mapGetters({
      childCommonObj: 'ChildService/commonObj'
    })
  },
  watch: {
    'search.org_id': function (newVal) {
        this.search.office_id = 0
        this.search.office_type_id = 0
        this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal) {
        this.search.office_id = 0
        this.search.office_id = this.$store.state.dataFilters.officeId
      this.getOfficeList()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
            }
        }
    }
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.search.office_id = this.$store.state.dataFilters.officeId
    this.loadData()
  },
  mounted () {
  },
  methods: {
    view (viewitem) {
      this.viewitemId = viewitem.id
        this.item = viewitem
    },
    edit (edititem) {
      this.editItemId = edititem.id
      this.item = edititem
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(disabilitySchoolServiceBaseUrl, ParentTrainingList, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
      let tmpOrganization = {}
      let tmpInstituteType = {}
      let tmpInstitute = {}
      const listData = data.map(item => {
        tmpOrganization = this.$store.state.commonObj.organizationProfileList.find(organization => organization.value === item.org_id)
        tmpInstituteType = this.$store.state.commonObj.officeTypeList.find(institute => institute.value === item.office_type_id)
        tmpInstitute = this.$store.state.commonObj.officeList.find(institute => institute.value === item.office_id)
        const traineeType = this.$store.state.DisabilitySchoolService.commonObj.traineeTypeList.find(el => el.value === item.trainee_type)

        const returnData = {
                    organization_name_bn: tmpOrganization !== undefined ? tmpOrganization.text_bn : '',
                    organization_name: tmpOrganization !== undefined ? tmpOrganization.text_en : '',
                    institute_type_name_bn: tmpInstituteType !== undefined ? tmpInstituteType.text_bn : '',
                    institute_type_name: tmpInstituteType !== undefined ? tmpInstituteType.text_en : '',
                    institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : '',
                    institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
                    trainee_type_en: traineeType !== undefined ? traineeType.text_en : '',
                    trainee_type_bn: traineeType !== undefined ? traineeType.text_bn : ''
                }
                return Object.assign({}, item, returnData)
            })
            return listData
        },
        getOfficeTypeList () {
            if (this.search.org_id) {
                this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id)
            }
        },
        getOfficeList () {
            if (this.search.office_type_id) {
                this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id)
            }
        }
  }
}
</script>
